
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BreastCancerRAndT',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/BreastCancerRAndT.vue